import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUISkeletonComponent } from './skeleton.component';

@NgModule({
  declarations: [
    CoreUISkeletonComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CoreUISkeletonComponent
  ]
})
export class CoreUISkeletonModule {}
